// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TwoColumnContent-module--wrapper--11F-V","left":"TwoColumnContent-module--left--1NQl4","right":"TwoColumnContent-module--right--FzL_W"};